import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ModalMapComponent } from './modal-map/modal-map.component';
@NgModule({
  imports: [CommonModule, DialogModule],
  declarations: [ModalMapComponent],
  exports: [ModalMapComponent]
})
export class SharedUiModalMapModule {}
